import { useMutation } from '@tanstack/react-query';

export function useCreateTwoFactorProvisioningMutation() {
  return useMutation({
    mutationFn: async () => {
      const response = await axios.post('/settings/two_factor/provisionings/');
      return response.data;
    },
  });
}

export function useCreateTwoFactorEnablementMutation() {
  return useMutation({
    mutationFn: async ({ otpAttempt }) => {
      const response = await axios.post('/settings/two_factor/enablement', {
        otp_attempt: otpAttempt,
      });
      return response.data;
    },
  });
}

export function useCreateTwoFactorDisablementMutation() {
  return useMutation({
    mutationFn: async ({ otpAttempt }) => {
      const response = await axios.post('/settings/two_factor/disablement', {
        otp_attempt: otpAttempt,
      });
      return response.data;
    },
  });
}

export function useCreateTwoFactorSetupSkipMutation() {
  return useMutation({
    mutationFn: async () => {
      const response = await axios.post('/settings/two_factor/setup_skip');
      return response.data;
    },
  });
}
